<template>
    <div class="analytics-header">
        <h1 class="analytics-title">Analytics</h1>
    </div>
</template>

<script>
export default {
    name: 'AnalyticsHeader'
};
</script>

<style scoped>
.analytics-header {
    margin-bottom: 40px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba(var(--accent-rgb), 0.6);
}

.analytics-title {
    font-size: 32px;
    color: var(--text-primary);
    margin: 0 0 10px 0;
}
</style>
